import React, { FC, useEffect, useRef, useState } from 'react';
import LabelSelect from 'src/components/atoms/selectbox/LabelSelect';
import Label from 'src/components/atoms/label/Default';
import InputBox from 'src/components/atoms/input/DefInputBox';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import InputDateBox from 'src/components/atoms/input/InputDateBox';
import HelpButton from 'src/components/atoms/buttons/HelpButton';
import CheckBox from 'src/components/atoms/CheckBox';
import SurveyButton from 'src/components/atoms/buttons/SurveyButton';
import FamilyDescription from 'src/components/molecules/table/FamilyDescription';
import { dateCalendarFormatType, getAge, formatBirthSimple } from 'src/utils/dateSet';
import { getResidentId, formatRRN, validateRRN } from 'src/utils/charSet';
import {
  isResidentTaxpayer,
  isElderlyDeductionApplied,
  isChildTaxDeductionApplied,
  computeChildOrderCode,
} from 'src/utils/familyDeduction';
import { fetchInsertFamilyData, fetchUpdateFamilyData } from 'src/fetch/stepA';
import { contentModalViewStore } from 'src/store/modal';
import { familyDataStore } from 'src/store/familyInfo';
import { currentTimeFormat } from 'src/utils/dateSet';
import { useQueryClient } from '@tanstack/react-query';
import { getMemberInfo, addComma, dateFormat } from 'src/utils/common';
import Spouse from 'src/components/organisms/template/StepA/Question/Spouse';
import Brother from 'src/components/organisms/template/StepA/Question/Brother';
import LinealAscendant from 'src/components/organisms/template/StepA/Question/LinealAscendant';
import LinealDescendant from 'src/components/organisms/template/StepA/Question/LinealDescendant';
import InsertForm from 'src/components/molecules/content/form/InsertForm';

import {
  isHandyType,
  isChildType,
  isYNType,
  isTargetType,
  isFullType,
  isYNSelect,
  familySelect,
  isTargetSelect,
  isHandySelect,
  isFullSelect,
  childSelect,
} from 'src/static/typeCode';
import {
  confirmModalViewStore,
  errorModalViewStore,
  loadingModalViewStore,
  contentModalDep2ViewStore,
} from 'src/store/modal';

import './style.scss';

interface Props {
  viewType?: string;
  formData?: any;
}
const FamilySetDiv: FC<Props> = ({ viewType, formData }) => {
  const deData = formData || {};

  const userInfoData: any = getMemberInfo();
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);

  const familySet = familyDataStore((state: any) => state.result).data || [];
  const familyResult = familyDataStore((state: any) => state.payload);
  const familyInitResult = familyDataStore((state: any) => state.initPayload);
  const familyInitBind = familyDataStore((state: any) => state.bindPayload);
  const familyInfoDataParam = familyDataStore((state: any) => state.param);
  const familyInfoDataBindParam = familyDataStore((state: any) => state.bindParam);

  // 입양일
  const adpoptDate = dateCalendarFormatType(deData.adopt_date || '');

  // 주민번호
  let residentNum = deData.res_id || '';
  if (residentNum.indexOf('-') === -1 && residentNum.length > 6) {
    residentNum = getResidentId(residentNum);
  }

  const residentPreArr = residentNum.split('-') || [];
  const residentPre = residentPreArr[0] || '';
  const familyAge = getAge(formatBirthSimple(residentPre));

  // 기존 저장된 부양가족을 열었을 때도(값 재입력 없이) 경로우대/장애인/자녀세액공제를 현재 규칙 기준으로 재계산
  useEffect(() => {
    const isEleDeductFieldItem: any = payloadState.payload.find(
      (item: any) => item.id === 'is_ele_deduct'
    );
    const resIdFieldItem: any = payloadState.payload.find((item: any) => item.id === 'res_id');
    recalcDependentDeductions(
      payloadState.payload,
      resIdFieldItem?.value || '',
      isEleDeductFieldItem?.value === 'Y'
    );
    setPayloadState({ payload: [...payloadState.payload] });
  }, []);

  // 배우자 체크
  // const spouseObj = familySet.filter((item: any) => item.family_type === '3');
  // if (spouseObj.length > 0) {
  //
  //   // to-be
  // }

  const calendarRef = useRef<HTMLInputElement | null>(null);
  // Modal Dep1
  const setContentModalState = contentModalViewStore((state: any) => state.set);
  // Modal Dep2
  const setContentModalDep2State = contentModalDep2ViewStore((state: any) => state.set);

  //가족 유형
  const familyTypeSelect = familySelect(deData.family_type);

  // 베우자 체크(기존 배우자값이 있으면 select에서 삭제)
  // const familyArr = familySet.filter((item: any) => item.family_type === '3');
  // if (familyArr.length > 0) {
  //   familyTypeSelect.options = familyTypeSelect.options.filter((item: any) => item.id !== '3');
  // }

  // Confiram Checkbox
  const checkAdoptionClickEvt = (e: any, status: string, field?: string) => {
    if (field) {
      const vType = status === 'on' ? 'N' : 'Y';
      familyResult[field] = vType;
      if (vType === 'Y') {
        familyResult.adopt_date = currentTimeFormat();
      } else {
        familyResult.adopt_date = '';
      }
      familyInitBind(familyResult);
    }
  };
  // Confiram Input
  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    familyResult[key] = e.target?.value || '';
    familyInitBind(familyResult);
  };

  // Confiram 주민번호
  const inpResChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    let value = e.target?.value.replace(/[^0-9]/g, ''); // 숫자만 허용
    if (value.length > 6) {
      value = value.slice(0, 6) + '-' + value.slice(6, 13);
    }
    familyResult[key] = value;
    familyInitBind(familyResult);
  };

  // Confirm Selectbox
  const confirmSelect = (item: any, field: string) => {
    familyResult[field] = item.id;
    familyInitBind(familyResult);
  };

  const familyQuestionSet = (id: string) => {
    // 직계존속
    if (id === '1' || id === '2') {
      setContentModalDep2State({
        active: '_active',
        title: '직계존속(부모,조부모)',
        content: <LinealAscendant />,
        styleDef: { width: '750px', height: '800px' },
      });
    }
    // 직계존속
    if (id === '4' || id === '5') {
      setContentModalDep2State({
        active: '_active',
        title: '직계비속(자녀,손자녀)',
        content: <LinealDescendant />,
        styleDef: { width: '750px', height: '800px' },
      });
    }
    // 배우자
    if (id === '3') {
      setContentModalDep2State({
        active: '_active',
        title: '배우자 기본 공제',
        content: <Spouse />,
        styleDef: { width: '750px', height: '800px' },
      });
    }
    // 형제자매
    if (id === '6') {
      setContentModalDep2State({
        active: '_active',
        title: '형제, 자매 기본 공제',
        content: <Brother />,
        styleDef: { width: '750px', height: '800px' },
      });
    }
  };

  // Insert 부양가족 추가
  const addEvt = () => {
    const payloadSet: any = {
      acct_year: userInfoData.acct_year,
      co_cd: userInfoData.co_cd,
      co_id: userInfoData.co_id,
    };

    payloadState.payload.forEach((item: any) => {
      let setValue = item.value;
      // 주민번호 '-' 등록 시 제거
      if (item.id === 'res_id') setValue = setValue.replaceAll('-', '');
      payloadSet[item.id] = setValue;
    });

    // 입양일 날짜 '.'제거
    if (payloadSet.is_adopt === 'Y') {
      let calendarDate = calendarRef.current?.value || '';
      calendarDate = calendarDate.replaceAll('.', '');
      payloadSet.adopt_date = calendarDate;
    } else {
      payloadSet.adopt_date = '';
    }

    // validation
    const { status } = validationParam(payloadSet);
    if (!status) {
      return false;
    }

    fetchInsertFamilyData(payloadSet, queryClient, errorModalState, loadingState, () => {
      const initialSeq = familyInfoDataParam.initialSeq || 0;
      familyInfoDataBindParam({ initialSeq: initialSeq + 1 });
      setContentModalState({
        active: '',
      });
    });
  };

  // Update 부양가족 수정
  const updateEvt = () => {
    const payloadSet: any = {
      acct_year: userInfoData.acct_year,
      co_cd: userInfoData.co_cd,
      co_id: userInfoData.co_id,
    };
    payloadState.payload.forEach((item: any) => {
      let setValue = item.value;
      // 주민번호 '-' 등록 시 제거
      if (item.id === 'res_id') setValue = setValue.replaceAll('-', '');
      payloadSet[item.id] = setValue;
    });

    // 입양일 날짜 '.'제거
    if (payloadSet.is_adopt === 'Y') {
      let calendarDate = calendarRef.current?.value || '';
      calendarDate = calendarDate.replaceAll('.', '');
      payloadSet.adopt_date = calendarDate;
    } else {
      payloadSet.adopt_date = '';
    }

    // validation
    const { status } = validationParam(payloadSet);
    if (!status) {
      return false;
    }

    fetchUpdateFamilyData(payloadSet, queryClient, errorModalState, loadingState, () => {
      const initialSeq = familyInfoDataParam.initialSeq || 0;
      familyInfoDataBindParam({ initialSeq: initialSeq + 1 });
      setContentModalState({
        active: '',
      });
    });
  };

  const validationParam = (payloadSet: any) => {
    const chkFamilySet = familySet.filter(
      (item: any) => item.family_seqid !== payloadSet.family_seqid
    );

    const resSet = { errText: { main: '', sub: '' }, status: true };
    //주민번호 체크
    // 800101-1234560
    // 801231-3234561
    if (!validateRRN(payloadSet.res_id)) {
      resSet.errText.main = '잘못된 주민등록 번호입니다.';
      resSet.errText.sub = '내용을 확인해 주세요.';
      resSet.status = false;
    }
    // 배우자 다중체크
    const thisArr = chkFamilySet.filter(
      (item: any) => item.family_type === '0' && payloadSet.family_seqid !== item.family_seqid
    );
    if (thisArr.length > 0 && payloadSet.family_type === '0') {
      resSet.errText.main = '이미 등록된 본인이 있습니다.';
      resSet.errText.sub = '본인은 여러명 선택할 수 없습니다.';
      resSet.status = false;
    }

    // 배우자 다중체크
    const familyArr = chkFamilySet.filter((item: any) => item.family_type === '3');

    if (familyArr.length > 0 && payloadSet.family_type === '3') {
      resSet.errText.main = '이미 등록된 배우자가 있습니다.';
      resSet.errText.sub = '배우자는 여러명 선택할 수 없습니다.';
      resSet.status = false;
    }

    // 배우자 있을경우(한부모공제)
    if (payloadSet.is_deduct_single_parent === 'Y') {
      if (familyArr.length > 0 || payloadSet.family_type === '3') {
        resSet.errText.main = '한부모 공제를 선택할 수 없습니다.';
        resSet.errText.sub = '등록된 배우자가 있으면 한부모 공제를 선택할 수 없습니다.';
        resSet.status = false;
      }
    }
    // 배우자 있을경우(부녀자공제 체크)
    if (payloadSet.is_deduct_women === 'Y') {
      if (familyArr.length > 0 || payloadSet.family_type === '3') {
        resSet.errText.main = '부녀자 공제를 선택할 수 없습니다.';
        resSet.errText.sub = '등록된 배우자가 있으면 부녀자 공제를 선택할 수 없습니다.';
        resSet.status = false;
      }
    }

    // 공백체크
    if (payloadSet.name.trim() === '') {
      if (familyArr.length > 0) {
        resSet.errText.main = '성명을 입력해 주세요.';
        resSet.errText.sub = '';
        resSet.status = false;
      }
    }

    const singleParentExtArr = chkFamilySet.filter(
      (item: any) => item.is_deduct_single_parent === 'Y'
    );
    if (singleParentExtArr.length > 0) {
      if (payloadSet.family_type === '3') {
        resSet.errText.main = '배우자를 선택할 수 없습니다.';
        resSet.errText.sub = '한부모공제가 등록되어 있으면 배우자 선택을할 수 없습니다.';
        resSet.status = false;
      }
    }
    const debutWomenExtArr = chkFamilySet.filter((item: any) => item.is_deduct_women === 'Y');

    if (debutWomenExtArr.length > 0) {
      if (payloadSet.family_type === '3') {
        resSet.errText.main = '배우자를 선택할 수 없습니다.';
        resSet.errText.sub = '부녀자 공제가 등록되어 있으면 배우자 선택을할 수 없습니다.';
        resSet.status = false;
      }
    }

    if (!resSet.status)
      errorModalState({
        data: { mainTitle: resSet.errText.main, subTitle: resSet.errText.sub },
        active: '_active',
      });

    return resSet;
  };

  const inpRef = useRef<HTMLInputElement | null>(null);
  const help = { content: '건강보험 산정 특례자 여부 내용', title: '건강보험 산정 특례자 여부' };

  // 기본공제 대상자 여부에 따라 경로우대공제/장애인공제/자녀세액공제를 재검토
  const recalcDependentDeductions = (payload: any[], resNum: string, isEleDeducted: boolean) => {
    const familyTypeFieldItem: any = payload.find((item: any) => item.id === 'family_type');
    const familyTypeValue = familyTypeFieldItem?.value || '';
    const familySeqidFieldItem: any = payload.find((item: any) => item.id === 'family_seqid');
    const residentTaxpayer = isResidentTaxpayer(userInfoData);
    const member = {
      is_ele_deduct: isEleDeducted ? 'Y' : 'N',
      family_type: familyTypeValue,
      res_id: resNum,
      family_seqid: familySeqidFieldItem?.value,
    };

    // 경로우대공제: 본인(family_type '0')이면 거주자 여부와 무관하게 적용, 본인 외에는 소득자가 거주자인 경우에만 적용
    const isOldFieldItem: any = payload.find((item: any) => item.id === 'is_old');
    if (isOldFieldItem) {
      const isOldValue = isElderlyDeductionApplied(member, userInfoData.acct_year, residentTaxpayer)
        ? 'Y'
        : 'N';
      isOldFieldItem.value = isOldValue;
      isOldFieldItem.select = isTargetSelect(isOldValue);
      isOldFieldItem.text = isOldFieldItem.select.checked?.value;
    }

    // 장애인공제도 기본공제 대상자에 한해 적용되므로, 기본공제 미대상이면 비장애인으로 초기화
    const isHandyFieldItem: any = payload.find((item: any) => item.id === 'is_handy');
    if (isHandyFieldItem && !isEleDeducted) {
      isHandyFieldItem.value = '0';
      isHandyFieldItem.select = isHandySelect('0');
      isHandyFieldItem.text = isHandyFieldItem.select.checked?.value;
    }

    // 자녀세액공제: 기본공제 대상자 + 소득자(본인) 거주자 + 직계비속 자녀·입양자(4)/위탁아동(8) + 귀속연도 기준 만 8세 이상
    const childDeductionFieldItem: any = payload.find((item: any) => item.id === 'child_deduction');
    if (childDeductionFieldItem) {
      const childDeductionValue = isChildTaxDeductionApplied(
        member,
        userInfoData.acct_year,
        residentTaxpayer
      )
        ? 'Y'
        : 'N';
      childDeductionFieldItem.value = childDeductionValue;
      childDeductionFieldItem.select = isTargetSelect(childDeductionValue);
      childDeductionFieldItem.text = childDeductionFieldItem.select.checked?.value;
    }

    // 자녀구분(첫째/둘째/셋째이상): 주민번호(생년월일)로 직계비속 자녀 중 출생순서를 판정
    const childCdFieldItem: any = payload.find((item: any) => item.id === 'child_cd');
    if (childCdFieldItem) {
      const childCdValue = computeChildOrderCode(member, familySet);
      childCdFieldItem.value = childCdValue;
      childCdFieldItem.select = childSelect(childCdValue);
      childCdFieldItem.text = childCdFieldItem.select.checked?.value;
    }
  };

  const payload = [
    // {
    //   label: '사번',
    //   value: deData.co_id || userInfoData.co_id,
    //   id: 'co_id',
    //   list: 'Y',
    //   insert: 'D',
    //   update: 'D',
    //   type: 'text',
    // },
    {
      label: '성명',
      value: deData.name || '',
      id: 'name',
      list: 'N',
      insert: 'Y',
      update: 'N',
      type: 'text',
    },
    {
      label: '부양가족 sequence',
      value: deData.family_seqid || '',
      id: 'family_seqid',
      list: 'N',
      insert: 'N',
      update: 'N',
      type: 'text',
    },
    {
      label: '가족유형',
      text: familyTypeSelect.checked?.value,
      value: deData.family_type || '0',
      id: 'family_type',
      insert: 'Y',
      type: 'select',
      select: familyTypeSelect,
      customEvt: (item: any) => {
        //Custom
        const customFieldItem: any = payloadState.payload.find(
          (item: any) => item.id === 'family_type'
        );
        const checkId = item.select.checked?.id || '';
        customFieldItem.value = checkId || '';
        customFieldItem.text = item.select.checked?.value || '';

        // Add Event
        const addItem = ['1', '2', '3', '4', '5', '6'].includes(checkId) ? (
          <div className="_btn">
            <SurveyButton clickEvent={e => familyQuestionSet(checkId)} />
          </div>
        ) : (
          ''
        );
        customFieldItem.addHtml = addItem;

        //직계비속(입양여부) 체크
        const adoptFieldItem: any = payloadState.payload.find(
          (item: any) => item.id === 'is_adopt'
        );
        const adoptDateFieldItem: any = payloadState.payload.find(
          (item: any) => item.id === 'adopt_date'
        );
        if (['4', '5'].includes(checkId)) {
          adoptFieldItem.insert = 'Y';
          adoptFieldItem.update = 'Y';
          adoptFieldItem.view = 'Y';
          if (adoptFieldItem.value === 'Y') {
            adoptDateFieldItem.insert = 'Y';
            adoptDateFieldItem.update = 'Y';
            adoptDateFieldItem.view = 'Y';
          }
        } else {
          adoptFieldItem.insert = 'N';
          adoptFieldItem.update = 'N';
          adoptFieldItem.view = 'N';
        }

        // 가족유형이 바뀌면 현재 기본공제 상태를 기준으로 자녀세액공제 등을 재검토
        const resIdFieldItem: any = payloadState.payload.find(
          (item: any) => item.id === 'res_id'
        );
        const isEleDeductFieldItem: any = payloadState.payload.find(
          (item: any) => item.id === 'is_ele_deduct'
        );
        recalcDependentDeductions(
          payloadState.payload,
          resIdFieldItem?.value || '',
          isEleDeductFieldItem?.value === 'Y'
        );

        setPayloadState({ payload: [...payloadState.payload] });
      },
      zIndex: '20',
    },
    {
      label: '주민번호',
      value: getResidentId(deData.res_id || ''),
      text: getResidentId(deData.res_id || ''),
      id: 'res_id',
      insert: 'Y',
      type: 'text',
      customEvt: (item: any, value: any) => {
        const customFieldItem: any = payloadState.payload.find((item: any) => item.id === 'res_id');
        const resNum: any = formatRRN(value);
        if (resNum || resNum === '') {
          customFieldItem.value = resNum;
        }
        // 주민번호가 바뀌면 현재 기본공제 상태를 기준으로 경로우대/장애인공제를 재검토
        const isEleDeductFieldItem: any = payloadState.payload.find(
          (item: any) => item.id === 'is_ele_deduct'
        );
        const isEleDeducted = isEleDeductFieldItem?.value === 'Y';
        recalcDependentDeductions(payloadState.payload, resNum, isEleDeducted);

        setPayloadState({ payload: [...payloadState.payload] });
      },
      addHtml: (
        <div className="_age_desc">
          (만 <em>{familyAge}</em>세)
        </div>
      ),
    },
    {
      label: '외국인여부',
      text: isYNSelect(deData.is_foreign).checked?.value || '',
      value: deData.is_foreign || 'N',
      id: 'is_foreign',
      insert: 'Y',
      type: 'check',
      select: isYNSelect(deData.is_foreign),
      zIndex: '15',
    },
    {
      label: '가족코드',
      value: deData.family_cd || '',
      id: 'family_cd',
      insert: 'N',
      list: 'N',
      update: 'N',
      type: 'text',
    },
    {
      label: '입양여부',
      text: isTargetSelect(deData.is_adopt).checked?.value,
      value: deData.is_adopt || 'N',
      id: 'is_adopt',
      list: ['4', '5'].includes(deData.family_type) ? 'Y' : 'N',
      insert: ['4', '5'].includes(deData.family_type) ? 'Y' : 'N',
      update: ['4', '5'].includes(deData.family_type) ? 'Y' : 'N',
      type: 'check',
      select: isTargetSelect(deData.is_adopt),
      customEvt: (item: any) => {
        //Custom
        const customFieldItem: any = payloadState.payload.find(
          (item: any) => item.id === 'adopt_date'
        );
        if (item.value === 'Y') {
          customFieldItem.insert = 'Y';
          customFieldItem.update = 'Y';
        } else {
          customFieldItem.insert = 'N';
          customFieldItem.update = 'N';
          customFieldItem.list = 'N';
          customFieldItem.value = '';
          customFieldItem.text = '';
        }
        setPayloadState({ payload: [...payloadState.payload] });
      },
      zIndex: '9',
    },
    {
      label: '입양일자',
      text: dateFormat(deData.adopt_date || ''),
      value: deData.adopt_date || '',
      id: 'adopt_date',
      insert: ['4', '5'].includes(deData.family_type) && deData.is_adopt === 'Y' ? 'Y' : 'N',
      update: ['4', '5'].includes(deData.family_type) && deData.is_adopt === 'Y' ? 'Y' : 'N',
      list: ['4', '5'].includes(deData.family_type) && deData.is_adopt === 'Y' ? 'Y' : 'N',
      type: 'date',
      zIndex: '8',
    },
    {
      label: '건강보험산정특례자 여부',
      text: isTargetSelect(deData.is_hc_exception).checked?.value,
      value: deData.is_hc_exception || 'N',
      id: 'is_hc_exception',
      insert: 'Y',
      type: 'check',
      select: isTargetSelect(deData.is_hc_exception),
      zIndex: '5',
      addHtml: (
        <div className="_help_div">
          <HelpButton content={help.content} title={help.title} />
        </div>
      ),
    },
    {
      label: '소득요건',
      text: isFullSelect(deData.is_incom).checked?.value,
      value: deData.is_incom || 'N',
      id: 'is_incom',
      insert: 'Y',
      type: 'check',
      select: isFullSelect(deData.is_incom),
      zIndex: '4',
    },
    {
      label: '기본공제여부',
      text: isTargetSelect(deData.is_ele_deduct).checked?.value,
      value: deData.is_ele_deduct || 'N',
      id: 'is_ele_deduct',
      insert: 'Y',
      list: 'N',
      update: 'Y',
      type: 'check',
      select: isTargetSelect(deData.is_ele_deduct),
      customEvt: (item: any) => {
        const isEleDeducted = item.value === 'Y';
        // 기본공제 체크 시 주민번호 기준으로 경로우대공제 재검토, 해제 시 경로우대/장애인공제 비활성화
        const resIdFieldItem: any = payloadState.payload.find((i: any) => i.id === 'res_id');
        recalcDependentDeductions(payloadState.payload, resIdFieldItem?.value || '', isEleDeducted);
        setPayloadState({ payload: [...payloadState.payload] });
      },
      zIndex: '13',
    },
    {
      label: '경로우대자공제',
      text: isTargetSelect(deData.is_old).checked?.value,
      value: deData.is_old || 'N',
      id: 'is_old',
      insert: 'N',
      list: 'N',
      update: 'N',
      type: 'check',
      select: isTargetSelect(deData.is_old),
      zIndex: '12',
    },
    {
      label: '부녀자공제여부',
      text: isTargetSelect(deData.is_deduct_women).checked?.value,
      value: deData.is_deduct_women || 'N',
      id: 'is_deduct_women',
      insert: 'N',
      list: 'N',
      update: 'N',
      type: 'check',
      select: isTargetSelect(deData.is_deduct_women),
      zIndex: '11',
    },
    {
      label: '한부모공제여부',
      text: isTargetSelect(deData.is_deduct_single_parent).checked?.value,
      value: deData.is_deduct_single_parent || 'N',
      id: 'is_deduct_single_parent',
      insert: 'N',
      list: 'N',
      update: 'N',
      type: 'check',
      select: isTargetSelect(deData.is_deduct_single_parent),
      zIndex: '10',
    },
    {
      label: '장애인여부',
      text: isHandySelect(deData.is_handy).checked?.value,
      value: deData.is_handy || '0',
      id: 'is_handy',
      insert: 'N',
      list: 'N',
      update: 'N',
      type: 'select',
      select: isHandySelect(deData.is_handy),
      zIndex: '7',
    },
    {
      label: '자녀구분',
      text: childSelect(deData.child_cd).checked?.value,
      value: deData.child_cd || '0',
      id: 'child_cd',
      insert: 'N',
      update: 'N',
      list: 'N',
      type: 'select',
      select: childSelect(deData.child_cd),
      zIndex: '19',
    },
    {
      label: '자녀세액공제여부',
      text: isTargetSelect(deData.child_deduction).checked?.value,
      value: deData.child_deduction || 'N',
      id: 'child_deduction',
      insert: 'N',
      list: 'N',
      update: 'N',
      type: 'check',
      select: isTargetSelect(deData.child_deduction),
      zIndex: '18',
    },
    // {
    //   label: '자녀구분',
    //   text: isTargetSelect(deData.child_cd).checked?.value,
    //   value: deData.child_cd,
    //   id: 'child_cd',
    //   insert: 'N',
    //   list: 'N',
    //   update: 'N',
    //   type: 'check',
    //   select: isTargetSelect(deData.child_cd),
    //   zIndex: '6',
    // },
  ];

  const [payloadState, setPayloadState] = useState({ payload });
  const [viewState, setViewState] = useState({ type: viewType });

  const updateUserEvt = () => {
    setViewState({ type: 'update' });
  };
  const cancleUserEvt = () => {
    setViewState({ type: 'view' });
    setPayloadState({ payload });
  };

  const topBtnDiv = () => {
    if (viewState.type === 'update') {
      return (
        <div className="_top_button_div">
          <div className="_btn_div">
            <DefaultButton
              text="수정"
              clickEvent={e => updateEvt()}
              icon=""
              status=""
              type="type3"
              styleDef={{
                width: '100px',
                height: '32px',
                fontSize: '13px',
              }}
            />
          </div>
          <div className="_btn_div">
            <DefaultButton
              text={'취소'}
              clickEvent={e => cancleUserEvt()}
              icon=""
              status=""
              type={'type1'}
              styleDef={{
                width: '100px',
                height: '32px',
                fontSize: '13px',
              }}
            />
          </div>
        </div>
      );
    } else if (viewState.type === 'insert') {
      return (
        <div className="_top_button_div">
          <div className="_btn_div">
            <DefaultButton
              text="부양가족 추가"
              clickEvent={e => addEvt()}
              icon=""
              status=""
              type="type3"
              styleDef={{
                width: '120px',
                height: '32px',
                fontSize: '13px',
              }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className="_top_button_div">
          <div className="_btn_div">
            <DefaultButton
              text="데이터 수정"
              clickEvent={e => updateUserEvt()}
              icon=""
              status=""
              type={'type2'}
              styleDef={{
                width: '120px',
                height: '32px',
                fontSize: '13px',
              }}
            />
          </div>
        </div>
      );
    }
  };

  return (
    <div className="_family_set_insert_div">
      {topBtnDiv()}
      <section className="_insert_section">
        <InsertForm state={payloadState} setState={setPayloadState} viewStatus={viewState.type} />
      </section>
      <section className="_info_section">
        <FamilyDescription
          state={payloadState}
          setState={setPayloadState}
          viewStatus={viewState.type}
        />
      </section>
      <section className="_btn_section">
        <div className="_btn_div">
          {viewState.type === 'update' ? (
            <DefaultButton
              text="수정"
              clickEvent={e => updateEvt()}
              icon=""
              status=""
              type="type3"
              styleDef={{
                width: '250px',
              }}
            />
          ) : (
            ''
          )}
          {viewState.type === 'insert' ? (
            <DefaultButton
              text="부양가족 추가"
              clickEvent={e => addEvt()}
              icon=""
              status=""
              type="type3"
              styleDef={{
                width: '250px',
              }}
            />
          ) : (
            ''
          )}
        </div>
      </section>
    </div>
  );
};

export default FamilySetDiv;
